import { Outlet } from "react-router-dom"
import PublicNavbar from "@/components/shared/PublicNavbar"
import PublicFooter from "@/components/shared/PublicFooter"
import { GoogleAnalytics } from "@/components/shared/GoogleAnalytics"
import { GA_ID } from "@/lib/appConfig"

export default function PublicLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-background">
            <GoogleAnalytics id={GA_ID} />
            <PublicNavbar />
            <main className="flex-1 w-full flex flex-col pt-16">
                <Outlet />
            </main>
            <PublicFooter />
        </div>
    )
}
